import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiStockObj, ApiStockObjFilter } from "./types";

interface StockObjsListResponse {
    stockobjs: ApiStockObj[];
}

/**
 * Транспортный слой OMP — объекты склада (ТМЦ).
 */
export const stockObjsApi = {
    /**
     * Загружает объекты склада (ТМЦ) по фильтру.
     * Запрос уходит в endpoint `stockobjs.loadByFilter`.
     */
    load: async (params: { flt?: ApiStockObjFilter }, config?: RequestConfig): Promise<ApiStockObj[]> => {
        const data = await ompApiClient.postOmega<StockObjsListResponse>("stockobjs.loadByFilter", params, config);
        return data.stockobjs;
    },
} as const;
